import React from 'react';
import Headerr from '../components/layout/header';
import Navbar from '../components/layout/navbar';
import Sec1bookingp2 from '../sections/sec1-booking2';
import { useState } from 'react';
import { useEffect } from 'react';
import Preloader from '../components/common/preloader';


const Booking2 = () => {
              const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 2000);
    return () => clearTimeout(timer);
  }, []);

  if (loading) return <Preloader />
    return ( 
        <>
                    <main className='home-background'>
                        <Headerr />
                        <Sec1bookingp2 />
                        <Navbar />
                    </main>
        </>
     );
}
 
export default Booking2;